<script>
  import { initializeApp } from "firebase/app";
  import {
    getFirestore,
    getDoc,
    doc,
    addDoc,
    updateDoc,
    serverTimestamp,
    increment,
    collection,
    getDocs,
    runTransaction,
    writeBatch,
    setDoc,
  } from "firebase/firestore/lite";
import {answered} from "./helper"

  const firebaseConfig = {
    apiKey: "AIzaSyCws39J-cambnP0baMzvGnwybBkn2sFP0c",
    authDomain: "virtual-confirm.firebaseapp.com",
    projectId: "virtual-confirm",
    storageBucket: "virtual-confirm.appspot.com",
    messagingSenderId: "61094073873",
    appId: "1:61094073873:web:ed1d7f9e3a650e91e343b0",
    measurementId: "G-YSDMBR65HE",
  };

  let swedish = true;

  //var start= performance.now()

  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);

  import Question from "./question.svelte";
  let name = "";

  let _questions = [];
  let gotcode = false;
  let disableButton = false;

  let showTimer = false;
  let answeredAll = false;

  fidx();

  async function copyCache() {
    const c = doc(db, "Caches", "jD8suezX7pazOtlUGsum");
    const docSnap = await getDoc(c);

    const data = docSnap.data();
    addDoc(collection(db, "Caches"), data);
  }

  async function fidx() {
    const c = doc(db, "Caches", "jD8suezX7pazOtlUGsum");
    const docSnap = await getDoc(c);

    const questions1 = await collection(docSnap.ref, "Questions");

    const a = await getDocs(questions1);
    //console.log(" a: " + a.docs);

    let qs = [];

    a.docs.forEach((doc) => {
      const q = doc.data();
      //console.log(q);
      //   questions.push(q);
      qs.push(q);
    });

    _questions = qs;

    _questions.push({
      text:"Hur många bultar sitter i plåten på stora tornets baksida?",
      text_eng:"Hur många bultar sitter i plåten på stora tornets baksida?",
      alts:[
        {
          text:"10"
        },
        
        {
          text:"13"
        },
        {
          text:"11"
        },
        {
          text:"12"
        },

      ]
    })

//console.log(_questions)

    let cache = { ...docSnap.data() };
    //console.log("cache", cache);
    document.title = cache.name;
    name = cache.name;
  }
  let code = "A7B5";

  let codes = [];
  function makeCodes(n) {
    for (let index = 0; index < n; index++) {
      let code = makeid(4);

      if (codes.indexOf(code) == -1) {
        codes.push(code);
      } else {
        //console.log(code + " fanns redan");
      }
    }

    //console.log("Code length", codes.length, codes);

    save(codes);
  }

  function makeid(length) {
    var result = "";
    var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var numbers = "0123456789";
    //var characters = 'A';

    var lettersLength = letters.length;
    var numbersLength = numbers.length;

    for (var i = 0; i < length; i++) {
      if (i % 2 == 0)
        result += letters.charAt(Math.floor(Math.random() * lettersLength));
      else result += numbers.charAt(Math.floor(Math.random() * numbersLength));
    }

    code = result;
    return result;
  }

  function generateFirestoreId() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let autoId = "";
    for (let i = 0; i < 20; i++) {
      autoId += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    //assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
    return autoId;
  }

  // async function save(docs) {
  //   var i,
  //     j,
  //     temporary,
  //     chunk = 400;
  //   for (i = 0, j = docs.length; i < j; i += chunk) {
  //     temporary = docs.slice(i, i + chunk);

  //     //console.log(temporary);
  //     const batch = writeBatch(db);

  //     temporary.forEach((code) => {
  //       const codeRef = doc(db, "UnusedCodes", generateFirestoreId());
  //       batch.set(codeRef, { code: code });
  //     });

  //     ////  await batch.commit();
  //   }
  // }


  let time = 10;

  function refreshAlt() {
    const noQuestions = _questions.length;
    let noAnswers = 0;
    _questions.forEach((q) => {
      q.alts.forEach((alt) => {
        if (alt.selected == true) noAnswers++;
      });
    });

    answeredAll = noAnswers == noQuestions;
  }
  async function sendAnswer() {
    //   //console.log("ha");
    //   gotcode = !gotcode;
    //  makeid(4);

    disableButton = true;

    let answer = "";

    _questions.forEach((q) => {
      q.alts.forEach((a) => {
        if (a.selected) answer +=a.answer?a.answer: a.text;
      });
    });

    //console.log("answer " + answer);
    const c = doc(db, "Answers", answer);
    const docSnap = await getDoc(c);

  //console.log(docSnap.data());
    //token
    //790a9984-9b16

    if (docSnap.exists()) {
      gotcode = true;
      //console.log("rätt svar");
      code = makeid(4);
      addDoc(collection(db, "UsedCodes"), {
        code: code,
        token: "790a9984-9b16",
        created: serverTimestamp(),
      });
    } else {
      //console.log("fel svar");

      answered.set({wrong:true, foo:Math.random()})

      setTimeout(() => {
        showTimer = true;
      }, 250);

      time = 30;
      var interval = setInterval(() => {
        time--;
        if (time < 1) {
          clearInterval(interval);
          showTimer = false;
          disableButton = false;
        }
      }, 1000);
    }
  }

  function getPersistentDate() {
    return Date.now().toLocaleString();
  }

  
</script>

<header>
  <div class="lang_selector">
    <div class="" class:selected={swedish} on:click={() => (swedish = true)}>
      SVENSKA
    </div>
    <div>/</div>
    <div class="" class:selected={!swedish} on:click={() => (swedish = false)}>
      ENGLISH
    </div>
  </div>

  <h1 class="title">
    <!-- {swedish ? "Hej" : "Hello"} -->
    {name}
  </h1>
</header>
<!-- <pre>
  {JSON.stringify(_questions, null,3)}
</pre>
<button on:click="{()=>{//console.log('tjo',_questions)}}">klick</button> -->


<section class="" style="padding: 0; display: flex; justify-content: center;">
  <div class="container ">
    {#if !gotcode}
      <div id="questions">
        {#each _questions as q}
          <Question
            question={swedish ? q.text : q.text_eng}
            alts={q.alts}
            altUpdated={refreshAlt}

            answered={answered}
          />
        {/each}

        <div class="code">
          <p>
            {swedish
              ? " Om du svarar fel så måste du vänta i 30 sekunder innan du kan skicka in ett nytt svar."
              : "If you answer incorrectly, you must wait 30 seconds before you can submit a new answer."}
          </p>
          <div class="sendbutton">
            <!-- svelte-ignore missing-declaration -->
            {#if !disableButton}
              <button
                class="alt"
                on:click={() => sendAnswer()}
                class:disableButton
                disabled={disableButton || !answeredAll}
                >{swedish ? "Skicka in svar" : "Submit answer"}</button
              >
            {/if}

            {#if disableButton}
              <div
                class="timer"
                class:timerEnabled={showTimer}
                style="text-align: center;"
              >
                <div>Fel svar</div>
                <div>
                  {time} sekunder
                </div>
              </div>
            {/if}
          </div>
        </div>
      </div>
    {/if}

    {#if gotcode}
      <div class="code">
        <div>
          <div style="font-size: x-large; font-weight: bolder;" class="center">
            {swedish ? "Grattis!" : "Congratulations!"}
          </div>

          <p class="center">
            {swedish
              ? "Inkludera denna unika koden i din logg"
              : "Include this unique code in your log"}
          </p>
        </div>

        <div class="x">{code}</div>
      </div>
    {/if}
  </div>
</section>

<footer />

<!-- 
  <div class="code">
   
  </div> -->
<style>
  :root {
    --c1: #ffb26b;
    --c2: #939b62;
    --c2b: #686d45;
    --c3: #ffd56b;
    --c4: #ff7b54;

    --whitish: #eeeeee;
    --blackish: #555555;

    --text-dark: rgb(39, 39, 39);

    --button-shadow-blur: 4px;

    --text-clr-light: white;
    --text-clr-dark: black;

    --main-padding: 5px;

    --shadow: 2px 2px var(--button-shadow-blur) 0px rgb(0 0 0 / 75%);
    --shadow-light: -2px -2px var(--button-shadow-blur) 0px rgb(255 255 255);

    /* --shadow2: 5px 5px 16px 0px rgb(0 0 0 / 50%); */
  }

  .title {
    color: var(--c3);
    text-shadow: 1px 1px 2px black;
  }

  .sendbutton {
  }

  .sendbutton button {
    /* border-radius: 5px;
    font-weight: bold;
    min-width: 50%;
    text-transform: uppercase;
    transition: 200ms;
    transform: scale(1);
    box-shadow: var(--shadow2);
    background-color: var(--c3); */
  }

  .disableButton {
    transform: scale(0);
  }

  .timer {
    opacity: 0;
    color: red;
    text-shadow: 1px 1px 2px black;
    transition: 250ms;
    transform: scale(0);
    font-size: large;
    text-transform: uppercase;
  }

  .timerEnabled {
    opacity: 1;
    transform: scale(1);
  }
  .center {
    text-align: center;
  }
  header {
    background-color: var(--c2b);
    text-align: center;
    padding: var(--main-padding);
    color: var(--c3);

    /* -webkit-box-shadow: 0px 4px 17px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 4px 17px 0px rgba(0,0,0,0.75);
  box-shadow: 0px 4px 17px 0px rgba(0,0,0,0.75); */

    margin-bottom: 10px;
  }

  .lang_selector {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
  }

  .lang_selector * {
    cursor: pointer;
    user-select: none;
  }

  .selected {
    font-weight: bolder;
    font-weight: 800;
  }

  .code {
    /* background-color: var(--c3); */
    margin-top: 1rem;
    text-shadow: none;
    color: black;
    flex-direction: column;
    display: flex;
    align-items: center;
    /* padding: 25px; */
    text-align: center;
    /* box-shadow: var(--shadow); */
  }

  .code .x {
    font-size: 5rem;
    font-family: monospace;
    outline: 2px solid black;
    outline-style: dashed;
    padding: 1rem;
    background-color: white;
    margin: 25px;

    /* background-color: var(--c5); */
  }

  .content {
    flex: 1 0 auto;
  }

  .content > div {
    padding: var(--main-padding);
    /* background-color: yellowgreen;
      border:1px solid red; */
  }
  /* .footer {
    flex-shrink: 0;
  } */

  h1 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  p {
    text-shadow: none;
  }

  .container {
    background-color: var(--whitish);

    margin: var(--main-padding);

    border-radius: 5px;
    box-shadow: var(--shadow);
    padding: 5px;
  }

  .alt {
    /* outline: 1px solid black; */

    /* width: 0px;
    flex-grow: 1; */
    text-align: center;

    transition: 500ms;
    cursor: pointer;
    text-shadow: none;
    box-shadow: var(--shadow);
    border-radius: 5px;
    /* background-color: var(--c1); */
    box-shadow: var(--shadow), var(--shadow-light);
    user-select: none;
    /* color: var(--c4); */
    padding: 10px;
    font-size: x-large;
  }

  .sendbutton {
    margin-bottom: 10px;
  }
</style>
